import React, { Component } from 'react';
import { Dropdown } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { userLogout } from '../user-pages/Login';
import { Search } from '../search/Search';
import ufeiLogo from '../../assets/images/ufei_logo.svg';

class Navbar extends Component {
  render() {
    return (
      <div className="flex-row">
        <nav className="navbar fixed-top p-0">
          <div className="navbar-brand-wrapper col-4">
            <Link className="navbar-brand brand-logo-mini" to="/"><img src={ufeiLogo} alt="logo" /></Link>
          </div>
            <div className="navbar-menu-wrapper">
              <form className="navbar-search-specific form-inline align-items-center justify-content-center">
                <Search />
              </form>
            </div>
          <div className="row mr-0">
            <ul className="navbar-nav-right" style={{ marginBottom: 0, padding: 0, paddingRight: 15 }}>
              {localStorage.getItem("loggedIn") === "true" && (
                <div className="">
                  <Dropdown alignright="true" className="nav-item">
                    <Dropdown.Toggle as="a" className="nav-link cursor-pointer no-caret">
                      <div className="navbar-profile">
                        <div className="mdi mdi-account-circle justify-items-center align-content-center" style={{ height: '1em', width: '10px', fontSize: '20px', color: "black" }}></div>
                        <p className="mb-0 d-none d-sm-block navbar-profile-name" style={{ color: "black" }}>{localStorage.getItem("firstname") + ' ' + localStorage.getItem("lastname")}</p>
                        <i className="mdi mdi-menu-down d-none d-sm-block"></i>
                      </div>
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="navbar-dropdown preview-list navbar-profile-dropdown-menu">
                      <h6 className="p-3 mb-0">Profile</h6>
                      <Dropdown.Divider />
                      <Dropdown alignright="true" className="nav-item d-none d-lg-block">
                        <Dropdown.Toggle className="nav-link btn btn-success create-new-button no-caret">
                          + Upload New Trees
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="navbar-dropdown preview-list create-new-dropdown-menu">
                          <h6 className="p-3 mb-0">Trees</h6>
                          <Dropdown.Divider />
                          <Dropdown.Item href="!#" onClick={evt => evt.preventDefault()} className="preview-item">
                            <div className="preview-thumbnail">
                              <div className="preview-icon bg-secondary rounded">
                                <i className="mdi mdi-file-outline text-primary"></i>
                              </div>
                            </div>
                            <div className="preview-item-content">
                              <p className="preview-subject">Tree Data</p>
                            </div>
                          </Dropdown.Item>
                          <Dropdown.Divider />
                          <Dropdown.Item href="!#" onClick={evt => evt.preventDefault()} className="preview-item">
                            <div className="preview-thumbnail">
                              <div className="preview-icon bg-secondary rounded">
                                <i className="mdi mdi-web text-info"></i>
                              </div>
                            </div>
                            <div className="preview-item-content">
                              <p className="preview-subject">City Data</p>
                            </div>
                          </Dropdown.Item>
                        </Dropdown.Menu>
                      </Dropdown>
                      <Dropdown.Divider />
                      <Dropdown.Item href="settings" className="preview-item">
                        <div className="preview-thumbnail">
                          <div className="preview-icon bg-secondary rounded">
                            <i className="mdi mdi-settings text-success"></i>
                          </div>
                        </div>
                        <div className="preview-item-content">
                          <p className="preview-subject mb-1">Settings</p>
                        </div>
                      </Dropdown.Item>
                      <Dropdown.Divider />
                      <Dropdown.Item href="logout" onClick={userLogout} className="preview-item">
                        <div className="preview-thumbnail">
                          <div className="preview-icon bg-secondary rounded">
                            <i className="mdi mdi-logout text-danger"></i>
                          </div>
                        </div>
                        <div className="preview-item-content">
                          <p className="preview-subject mb-1">Log Out</p>
                        </div>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              )}
              {localStorage.getItem("loggedIn") !== "true" && (
                <Link to="/login" alignright="true" as="li" type="button" className='nav-item btn btn-ufei'>
                  <div className='' style={{ whiteSpace: 'nowrap' }}>
                    <span><i className="mdi mdi-login text-white"></i></span>
                    <span>Login</span>
                  </div>
                </Link>
              )}
            </ul>
          </div>
        </nav >
      </div>
    );
  }
}

export default Navbar;